/* ============================================================
   PHOSIS BLOG — progressive enhancement
   - Article: build TOC from content headings, scroll-spy,
     reading progress bar, reveal sticky CTA after 30% scroll.
   - Index: Load-more (AJAX append) with history.pushState.
   All features degrade gracefully if their markup is absent.
   ============================================================ */
(function () {
  'use strict';

  function slugify(text, used) {
    var base = (text || 'section')
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 60) || 'section';
    var slug = base;
    var n = 2;
    while (used[slug]) { slug = base + '-' + n; n++; }
    used[slug] = true;
    return slug;
  }

  /* ---------- ARTICLE: Table of contents ---------- */
  function initToc(root) {
    var content = root.querySelector('.phosis-article__content');
    var rails = root.querySelectorAll('[data-toc-list]');
    if (!content || !rails.length) return;

    var headings = content.querySelectorAll('h2, h3');
    var used = {};
    var items = [];

    headings.forEach(function (h) {
      if (!h.id) h.id = slugify(h.textContent, used);
      else used[h.id] = true;
      items.push({ id: h.id, text: h.textContent, level: h.tagName.toLowerCase() });
    });

    // Need at least 2 headings to be useful — otherwise hide TOC.
    if (items.length < 2) {
      root.querySelectorAll('[data-toc]').forEach(function (el) { el.hidden = true; });
      var layout = root.querySelector('.phosis-article__layout');
      if (layout) layout.classList.add('phosis-article__layout--no-toc');
      return;
    }

    var linksById = {};
    rails.forEach(function (list) {
      var html = '';
      items.forEach(function (it) {
        html += '<li class="phosis-toc__item phosis-toc__item--' + it.level + '">' +
                '<a href="#' + it.id + '" data-toc-link="' + it.id + '">' + it.text + '</a></li>';
      });
      list.innerHTML = html;
    });

    root.querySelectorAll('[data-toc-link]').forEach(function (a) {
      var id = a.getAttribute('data-toc-link');
      (linksById[id] = linksById[id] || []).push(a);
      a.addEventListener('click', function (e) {
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + id);
      });
    });

    // Scroll-spy
    if ('IntersectionObserver' in window) {
      var current = null;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) current = entry.target.id;
        });
        Object.keys(linksById).forEach(function (id) {
          linksById[id].forEach(function (a) {
            a.parentElement.classList.toggle('is-active', id === current);
          });
        });
      }, { rootMargin: '-90px 0px -70% 0px', threshold: 0 });
      headings.forEach(function (h) { observer.observe(h); });
    }
  }

  /* ---------- ARTICLE: reading progress bar ---------- */
  function initProgress(root) {
    var bar = root.querySelector('[data-progress-bar]');
    var content = root.querySelector('.phosis-article__content');
    if (!bar || !content) return;

    function update() {
      var rect = content.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var scrolled = -rect.top;
      var pct = total > 0 ? Math.min(1, Math.max(0, scrolled / total)) : 0;
      bar.style.width = (pct * 100).toFixed(2) + '%';
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  /* ---------- ARTICLE: sticky CTA reveal after 30% scroll ---------- */
  function initStickyCta(root) {
    var els = root.querySelectorAll('[data-sticky-cta]');
    if (!els.length) return;
    var dismissed = false;

    root.querySelectorAll('[data-sticky-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        dismissed = true;
        els.forEach(function (el) { el.classList.remove('is-active'); });
      });
    });

    function onScroll() {
      if (dismissed) return;
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      var pct = max > 0 ? window.scrollY / max : 0;
      // Visible across the last 75% of the page: reveal after the first quarter, stay to the end.
      var show = pct > 0.25;
      els.forEach(function (el) { el.classList.toggle('is-active', show); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- INDEX: Load more ---------- */
  function initLoadMore(root) {
    var btn = root.querySelector('[data-loadmore-btn]');
    var grid = root.querySelector('[data-loadmore-grid]');
    if (!btn || !grid) return;

    btn.addEventListener('click', function () {
      var nextUrl = btn.getAttribute('data-next-url');
      if (!nextUrl) return;
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-loading-text') || 'Loading…';

      fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-loadmore-grid]');
          var newBtn = doc.querySelector('[data-loadmore-btn]');
          var newCount = doc.querySelector('[data-loadmore-count]');

          if (newGrid) {
            // Append only article cards — never the inline newsletter (a non-card grid child).
            newGrid.querySelectorAll('.phosis-card').forEach(function (card) {
              grid.appendChild(card.cloneNode(true));
            });
          }
          var count = root.querySelector('[data-loadmore-count]');
          if (count && newCount) count.textContent = newCount.textContent;

          // Update scroll position support without a full navigation.
          try { history.pushState({ phosisLoadMore: true }, '', nextUrl); } catch (e) {}

          if (newBtn && newBtn.getAttribute('data-next-url')) {
            btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
            btn.disabled = false;
            btn.textContent = btn.getAttribute('data-label') || 'Load more articles';
          } else {
            btn.hidden = true;
          }
        })
        .catch(function () {
          // Fall back to a normal navigation on failure.
          window.location.href = nextUrl;
        });
    });
  }

  /* ---------- INDEX: in-page category pill filter ---------- */
  function initCategoryFilter(root) {
    var pills = root.querySelectorAll('[data-pills] .phosis-pill');
    var grid = root.querySelector('[data-filter-grid]');
    if (!pills.length || !grid) return;
    var cards = grid.querySelectorAll('.phosis-card');
    var empty = root.querySelector('[data-empty]');

    function apply(filter) {
      var shown = 0;
      cards.forEach(function (card) {
        var tags = (card.getAttribute('data-tags') || '').split(' ');
        var show = filter === '*' || tags.indexOf(filter) > -1;
        card.style.display = show ? '' : 'none';
        if (show) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        apply(pill.getAttribute('data-filter'));
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-phosis-article]').forEach(function (root) {
      initToc(root);
      initProgress(root);
      initStickyCta(root);
    });
    document.querySelectorAll('[data-phosis-blog]').forEach(function (root) {
      initLoadMore(root);
      initCategoryFilter(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
